import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import defaultAssetImage from 'assets/img/Car2.png';
import {
  InsuranceDocumentAssetImage,
  InsuranceDocumentCard,
  InsuranceDocumentCardContentWrapper,
  InsuranceDocumentEditButton,
  InsuranceDocumentEditButtonIcon,
  InsuranceDocumentValue
} from './InsuranceDocumentListStyles';
import { useListBrowserUtils } from '@ts-private/list-browser';
import { insuranceDocumentsStore } from './InsuranceDocumentListBrowser';

const InsuranceDocument = ({ data, onEdit }) => {
  const { t } = useTranslation();
  const composeId = useCallback(key => `offerList_offer_${data.documentId}${key ? `_${key}` : ''}`, [data]);
  const { isFieldVisible } = useListBrowserUtils(insuranceDocumentsStore);

  return (
    <InsuranceDocumentCard gradientColor={data.color}>
      <InsuranceDocumentCardContentWrapper container spacing={1} id={composeId()} key={data.documentId}>
        {isFieldVisible('assetImage') && (
          <Grid item xs={12} sm={6} md={3} lg={2} pr={2}>
            <InsuranceDocumentAssetImage src={data.imageUrl || defaultAssetImage} alt='...' />
          </Grid>
        )}
        <Grid item container xs={12} lg={isFieldVisible('assetImage') ? 10 : 12}>
          {isFieldVisible('insuranceTypeName') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('partnerName')}>
              <strong> {t('Offer.List.Field.InsuranceType')}</strong>:{' '}
              <InsuranceDocumentValue>{data.insuranceTypeName}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('documentNumber') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('documentNumber')}>
              <strong> {t('Offer.List.Field.DocumentNumber')}</strong>:{' '}
              <InsuranceDocumentValue>{data.documentNumber}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('chassisNumber') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('chassisNumber')}>
              <strong> {t('Offer.List.Field.ChassisNumber')}</strong>: <InsuranceDocumentValue>{data.chassisNumber}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('issuedByName') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('issuedBy')}>
              <strong> {t('Offer.List.Field.IssuedBy')}</strong>: <InsuranceDocumentValue>{data.issuedByName}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('offerTypeName') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('offerType')}>
              <strong> {t('Offer.List.Field.OfferType')}</strong>: <InsuranceDocumentValue>{data.offerTypeName}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('documentStateName') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('offerStatus')}>
              <strong> {t('Offer.List.Field.DocumentState')}</strong>:{' '}
              <InsuranceDocumentValue>{data.documentStateName}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('userName') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('createdBy')}>
              <strong> {t('Offer.List.Field.CreatedBy')}</strong>: <InsuranceDocumentValue>{data.userName}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('documentDate') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('documentDate')}>
              <strong> {t('Offer.List.Field.DocumentDate')}</strong>:{' '}
              <InsuranceDocumentValue>{t('DATE', { date: data.documentDate })}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('clientName') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('client')}>
              <strong> {t('Offer.List.Field.ClientName')}</strong>: <InsuranceDocumentValue>{data.clientName}</InsuranceDocumentValue>
            </Grid>
          )}
          {isFieldVisible('vehicleName') && (
            <Grid item xs={12} sm={6} md={4} id={composeId('vehicle')}>
              <strong> {t('Offer.List.Field.Vehicle')}</strong>: <InsuranceDocumentValue>{data.vehicleName}</InsuranceDocumentValue>
            </Grid>
          )}
          <InsuranceDocumentEditButton to={onEdit(data)}>
            <IconButton id='offerList_editBtn' size='small' color='primary' tooltip={t('Tooltips.Edit')}>
              <InsuranceDocumentEditButtonIcon />
            </IconButton>
          </InsuranceDocumentEditButton>
        </Grid>
      </InsuranceDocumentCardContentWrapper>
    </InsuranceDocumentCard>
  );
};

InsuranceDocument.propTypes = {
  data: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired
};

export default InsuranceDocument;
